export default __webpack_public_path__ + "static/media/oven.e234695a.webp";